import { PropTypes } from 'prop-types';

const ViewField = ({ label, value }) => {
  if (!value) return null;
  if (typeof value === 'string') {
    const normalizedValue = value.toLowerCase();
    if (normalizedValue === 'blank' || normalizedValue.includes('unknown'))
      return null;
  }

  return (
    <div className="w-100">
      <span className="apps-grid-title">{label}</span>
      <p className="f7 pa0 ma0 midgrey-d1 nudge-bottom--2">{value}</p>
    </div>
  );
};

ViewField.propTypes = {
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default ViewField;
